import type React from 'react';

import { Button } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useShowPaypalButton } from '../hooks/useShowPaypalButton';
import { useMembershipModalState } from '../modalContext';

export const ContinueButton: React.FC = () => {
	const [{ formState, validationErrors }] = useMembershipModalState();
	const showPaypalButton = useShowPaypalButton();

	if (showPaypalButton) return null;

	const isLoading = formState?.status === 'loading';
	return (
		<Button
			variant="primary"
			type="submit"
			className="w-full"
			disabled={isLoading || !!validationErrors}
			loading={isLoading}
			data-qa="submit-payment-button"
			data-testid="submit-payment-button"
			tabIndex={0}
		>
			<Translate value="corgi.co.ppmu.modal.confirm" />
		</Button>
	);
};
